module.exports = __webpack_public_path__ + "img/news_all_hover.0f57369c.svg";